var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSamoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C5.49563 10.5044 10.1565 5.8435 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16 7.1635 16 6.12175 16 0C7.1635 0 0 7.1635 0 16H16Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.815 10.4348L13.074 11.232H13.9121L13.234 11.7245L13.4931 12.5217L12.815 12.029L12.1368 12.5217L12.3959 11.7245L11.7178 11.232H12.5559L12.815 10.4348Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60499 4.17374L9.03668 5.50242H10.4337L9.30343 6.32336L9.73524 7.65199L8.60499 6.8308L7.4748 7.65199L7.90655 6.32336L6.77637 5.50242H8.17324L8.60499 4.17374Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7786 5.56522L13.2103 6.89397H14.6072L13.477 7.7149L13.9087 9.04353L12.7786 8.22234L11.6484 9.04353L12.0801 7.7149L10.95 6.89397H12.3468L12.7786 5.56522Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48048 11.1301L9.91223 12.4588H11.3091L10.1789 13.2797L10.6107 14.6083L9.48048 13.7872L8.35029 14.6083L8.78204 13.2797L7.65186 12.4588H9.04879L9.48048 11.1301Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8227 7.65213L6.25445 8.98082H7.65139L6.52114 9.80175L6.95289 11.1304L5.8227 10.3093L4.69258 11.1304L5.12427 9.80175L3.99414 8.98082H5.39102L5.8227 7.65213Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamoa);
export default __webpack_public_path__ + "static/media/samoa.a38f98cc.svg";
export { ForwardRef as ReactComponent };